import React from 'react';

const Process = () => {
  const steps = [
    { icon: "/images/projects/discover.png", title: "Discover & Define", description: "We exploring device, network, and software needs to shape a precise IoT/IT project plan." },
    { icon: "/images/projects/design-icon.png", title: "Design Interface", description: "We Designing intuitive dashboards and interfaces to make IoT data easy to monitor and control." },
    { icon: "/images/projects/devlopment.png", title: "Development", description: "We developing reliable IoT and IT solutions that connect devices, process data, and automate workflows." },
    { icon: "/images/projects/testing.png", title: "Testing & Deliver", description: "We testing every IoT and IT component to ensure reliability, then deliver a fully working solution.." }
  ];

  return (
    <section id="process" className="bg-white">
      <div className="container-fluid">
        <div className="brands-grid separator-border">
          <div className="row">

            {steps.map((step, index) => (
              <div key={index} className="col-sm-6 col-lg-3">

                <div className="featured-box text-center my-5">

                  {/* ICON */}
                  <div className="featured-box-icon text-light-blue mb-2">
                    <img
                      src={step.icon}
                      alt={step.title}
                      style={{
                        width: "29px",
                        height: "40px",
                        objectFit: "contain"
                      }}
                    />
                  </div>

                  {/* TITLE */}
                  <h3 className="font-weight-400">{step.title}</h3>

                  {/* DESCRIPTION */}
                  <p className="text-muted text-3">{step.description}</p>

                </div>

              </div>
            ))}

          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
